import React from 'react';
import { Text, Badge } from 'components/elements';
import PropTypes from 'prop-types';
import * as S from './styles';

function OppRequirements({ data }) {
  return (
    <S.OppRequirements>
      <Text as="h3" variant="body2Bold" colour="neutral.700">
        You will need
      </Text>
      <Text className="oppRequirements__text" variant="body1" colour="neutral.700">
        In order to apply to this opportunity you will need
      </Text>
      <S.BadgeWrapper>
        {data.map((requirement) => (
          <Badge key={requirement} colourScheme="green" textTransform="uppercase" radius="full">
            {requirement}
          </Badge>
        ))}
      </S.BadgeWrapper>
    </S.OppRequirements>
  );
}

OppRequirements.defaultProps = {
  data: [],
};

OppRequirements.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
};

export default OppRequirements;
